module.exports = __webpack_public_path__ + "img/ícone-seta-direita-ultimo-cinza.3eb453d6.svg";